import './CSS/Estilo.css'
import {estiloGreen,estiloDark} from "./CSS/EstilosPagina";
import ToolBar from "./Componentes/SubComponentes/ToolBar"
import MenuDesplegable from "./Componentes/MenuDesplegable"
import BtOrax from "./Componentes/SubComponentes/BtOrax";
import Container from '@mui/material/Container';
import SendToMobileIcon from '@mui/icons-material/SendToMobile';
import Box from '@mui/system/Box';
import { useState,useCallback } from "react"
import {fetchRequest, SHA256} from "./Componentes/RequestUtils";


export default function OraxLogin({modo,ip,protocolo,port,modo_desarrollo})
{
    const pages = ((modo === 'oraxulux')?
        [ 'Documentos', 'Contacto', 'Inicio']:
        [ 'Inicio','Sobre nosotros', 'Contacto', 'Noticias y Actividades']);
    const opciones = ['Dark','Green']
    const [estiloPagina,setEstiloPagina]=useState((localStorage.getItem('estilo') === 'Dark')?estiloDark
        :estiloGreen);
    const[nombre,setNombre] = useState('');
    const[pwd,setPwd] = useState('');


    const opcionesOnClick = useCallback((ev) => {
        let pulsado = ev.target.id;
        let estilo = (pulsado === 'Dark')?estiloDark:estiloGreen;
        setEstiloPagina(() => estilo);
        localStorage.setItem('estilo',pulsado);
    },[]);

  //////////////////////////
  //
  //  MANEJADOR DEL EVENTO DE CANVIO DE TEXTO EN LAS CAJAS DE TEXTO
  //
  ////////////////////////////////////
  //
  function tb_Changed(ev){
    if(ev.target.id === 'tbNom')
      setNombre(()=> ev.target.value);
    else if(ev.target.id === 'tbPwd')
      setPwd(() => SHA256(ev.target.value));
  }
  //////////////////////////
  //
  //  MANEJADOR DEL EVENTO DE PULSAR LA TECLA INTRO EN LAS CAJAS DE TEXTO
  //
  ////////////////////////////////////
  //
  function tbEnter(ev){
    if(ev.key === "Enter")
    {
      if(ev.target.id === "tbNom")
        document.getElementById("tbPwd").focus();
      else
        document.getElementById("tbNom").focus();
    }
  }

  ///////////////////////////////////
  //
  //  MANEJADOR DEL EVENTO DE HACER CLICK SOBRE EL
  //  BUTON PARA ENVIAR EL NOMBRE Y PASSWORD
  //
  //////////////////////////////////////////
  //
  function btEnvio_clicked(){
      const callback = (response) => {
        if(response) {
          let result = ((JSON.parse(response)).data.login);
          if (result !== null) {
              sessionStorage.setItem('token',result.token);
              window.location = (modo === 'frater'?'/admin/?modo=frater':'/admin/?modo=oraxulux');
          } else
            alert("Error: Credenciales no válidas");
        }
        else
          alert("Error de comunicación con el servidor.");
    }
      fetchRequest('login',[{nombre:'nom',valor:nombre},{nombre:'pwd',valor:pwd}],
          'POST',ip,port,protocolo,'text',callback,['token','message'],modo_desarrollo);
  }


    return(
        <Box className='Login' style={{background:estiloPagina.background}}>
        <Box className='ToolBar'>
          <ToolBar estilo={estiloPagina} gadgets={[<MenuDesplegable 
                    key='1'
                    opciones={opciones}
                    opcionesOnClick={opcionesOnClick}></MenuDesplegable>]}
                    paginas={pages}
                    modo = {modo}>
            </ToolBar>
        </Box>
        <Box className='Cabecera'>
            <h1 style={{margin:'auto',color:(estiloPagina.background === 'black')?'white':'black',fontWeight:200}}>Login</h1>
        </Box>
        <Container sx={{ height:1/2}} style={{ height:'70%',display:'flex', alignItems:'center', 
               flexDirection:'column',paddingTop:'2%'}}>            
          <label id="lbNom"  className={'labelInput'} style={{color:(estiloPagina.background === 'black')?'white':'black'}} >Nombre de usuario</label>
          <input autoFocus onKeyDown={tbEnter} onChange={tb_Changed} id="tbNom" className='formInput'></input>          
          <label className={'labelInput'} style={{color:(estiloPagina.background === 'black')?'white':'black'}}>Password</label>
          <input onKeyDown={tbEnter} onChange={tb_Changed} type="password" id="tbPwd" className='formInput'></input>
            <BtOrax onClick={btEnvio_clicked} leyenda={'_Enviar'} color={'Green'} margenSup={'30px'}
                    alto={'50px'}
                    altoLetra={'19px'}
                    fontColor={'chartreuse'}
                    hoverBack={'Chartreuse'}
                    hoverColor={'Green'}
                    icono={<SendToMobileIcon  sx={{boxShadow:1}}/>}/>
        </Container>        
      </Box>
    )
}

